import { useEffect, useRef, useState } from 'react';

/** Width of an element (ResizeObserver), so the table adapts to the space the
 *  shell leaves (capability nav + Copilot rail), not just the viewport. */
export function useWidth<T extends HTMLElement>(): [import('react').RefObject<T>, number] {
  const ref = useRef<T>(null);
  const [w, setW] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    setW(el.clientWidth);
    if (typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(() => setW(el.clientWidth));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return [ref, w];
}
